<template>
    <div>
        <KpFileInput
            :value="record"
            :append-icon="showDownloadBtn && value ? 'ic ic-20 ic-download ic-col-grey' : null"
            :hide-input="!showInput"
            v-bind="$attrs"
            @change="change"
            @click:clear="clear"
            @click:append="downloadFile"
            v-on="$listeners"
        >
        </KpFileInput>
        <IconBtn
            v-if="!showInput"
            color="action"
            icon-cls="file"
            icon-color="white"
            icon-disabled-color="grey"
            :tooltip="tooltip"
            @click="$el.querySelector('input').click()"
        />
    </div>
</template>

<script>
import { apiUrl } from '@/helpers/globals';
import { instance as api } from '@/helpers/api';
import { Document, DocumentCollection } from '@/models/Document';
import { errToStr } from '@/helpers/tools';

export default {
    name: 'FileUploadField',
    props: {
        value: {
            type: Number,
            default: null,
        },
        showDownloadBtn: {
            type: Boolean,
            default: true,
        },
        showInput: {
            type: Boolean,
            default: true,
        },
        tooltip: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            record: null,
        };
    },
    computed: {},
    watch: {
        value: {
            async handler(value) {
                let record = null;
                try {
                    let id = null;
                    if (!value) {
                        return;
                    }
                    id = Number(value);
                    if (!id) {
                        return;
                    }

                    try {
                        const collection = new DocumentCollection();
                        await collection.query({ id });
                        const rec = collection.first();
                        if (rec) {
                            record = rec;
                        }
                    } catch (e) {
                        this.$toast({ message: errToStr(e), color: 'error' });
                    }
                } finally {
                    this.record = record;
                }
            },
            immediate: true,
        },
    },

    methods: {
        async change(file) {
            if (file instanceof Document) {
                return;
            }
            if (this.record) {
                await this.removeFile(this.record);
            }
            const fileData = await this.uploadFile(file);
            if (fileData) {
                this.updateValue(fileData.id);
            }
        },
        async uploadFile(file) {
            if (!file) {
                return null;
            }
            const url = 'Document/upload';
            const body = new FormData();
            body.append('file', file);
            try {
                const result = await api().post(url, body);
                if (result.data.documents && result.data.documents.length === 1) {
                    return result.data.documents[0];
                } else {
                    throw new Error(result.data.error);
                }
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
                return null;
            }
        },
        async clear() {
            if (this.record) {
                await this.removeFile(this.record);
                this.updateValue(null);
            }
        },
        async removeFile(record) {
            if (!record) {
                return null;
            }
            try {
                await record.delete();
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
            }
        },
        downloadFile() {
            if (!this.record) {
                return;
            }
            const url = apiUrl('Document/download', { document: this.record.id });
            window.open(url, this.record.name);
        },
        updateValue(value) {
            this.$emit('input', value);
        },
    },
};
</script>

<style lang="scss" scoped></style>
